var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStaticMessage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_552",
    "data-name": "Group 552",
    transform: "translate(-1787 -740)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_20",
    "data-name": "Rectangle 20",
    width: 64,
    height: 64,
    transform: "translate(1787 740)",
    fill: "rgba(255,255,255,0)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_520",
    "data-name": "Group 520",
    transform: "translate(-984.479 -1130.055)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15684",
    "data-name": "Path 15684",
    d: "M2822.46,1878.165l-4.95-2.856c-6.393-1.528-33.983,15.168-33.983,20.744l4.95,2.857c2.056-5.576,12.941-12.011,17.362-14.621C2810.028,1881.93,2818.554,1877.233,2822.46,1878.165Z",
    transform: "translate(0.106 0.108)",
    fill: "#c8e6fe",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15685",
    "data-name": "Path 15685",
    d: "M2784.067,1895.931l4.319,2.49c2.51-5.636,13.242-11.957,17.349-14.38,5.067-2.861,11.118-6,15.11-6.283l-3.381-1.951c-4.328-.927-18.9,6.7-27.423,13.439-3.6,2.846-5.75,5.258-5.973,6.686Zm4.516,3.5a.393.393,0,0,1-.2-.055l-4.965-2.858a.408.408,0,0,1-.2-.36c0-2.143,3.426-5.3,6.3-7.57,7.951-6.277,23.293-14.748,28.186-13.582a.372.372,0,0,1,.1.047l4.95,2.856a.412.412,0,0,1-.289.764c-3.907-.932-12.926,4.166-16.329,6.085-4.145,2.438-15.158,8.931-17.173,14.4a.411.411,0,0,1-.39.273Z",
    fill: "#2874e7",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15686",
    "data-name": "Path 15686",
    d: "M2787.135,1898.873c.659,21.488-2.779,34.595,17.431,28.538,20.2-17.254,16.774-26.4,17.457-48.656C2822.232,1871.64,2786.923,1892,2787.135,1898.873Z",
    transform: "translate(2.367 0.827)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15687",
    "data-name": "Path 15687",
    d: "M2787.667,1898.968c.092,3.158.1,6.076.1,8.894.039,9.646.05,16.612,3.767,19.373,2.475,1.827,6.583,1.8,12.926-.089,17.031-14.567,17.068-23.347,17.127-39.268.011-2.829.022-5.756.118-9.026a.84.84,0,0,0-.386-.835c-1.821-1.065-9.115,1.692-17.375,6.573-9.522,5.629-16.376,11.675-16.279,14.38Zm8.783,30.445a8.8,8.8,0,0,1-5.406-1.516c-4.046-3-4.07-10.146-4.1-20.033,0-2.814-.01-5.723-.106-8.871h0c-.116-3.562,8.3-10.162,16.693-15.118,6.767-4,15.59-8.12,18.217-6.575a1.663,1.663,0,0,1,.8,1.574c-.109,3.26-.109,6.181-.119,9.007-.058,16.187-.093,25.106-17.478,39.954a.733.733,0,0,1-.153.081,29.957,29.957,0,0,1-8.344,1.5Z",
    transform: "translate(1.261 0.722)",
    fill: "#2874e7",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15688",
    "data-name": "Path 15688",
    d: "M2800.053,1900.36l-.01,22.456h.01c14.476-12.361,16.82-20.561,17.231-32.4Z",
    transform: "translate(5.88 5.423)",
    fill: "#c8e6fe",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15689",
    "data-name": "Path 15689",
    d: "M2800.57,1900.708v21.314c13.114-11.385,15.872-19.157,16.376-30.766Zm-.42,22.632a.425.425,0,0,1-.239-.073.433.433,0,0,1-.171-.344v-22.456a.424.424,0,0,1,.208-.362l17.23-9.945a.419.419,0,0,1,.425,0,.4.4,0,0,1,.2.371c-.432,12.474-3.145,20.551-17.372,32.7a.6.6,0,0,1-.128.073.427.427,0,0,1-.153.037Z",
    transform: "translate(5.774 5.315)",
    fill: "#2874e7",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15690",
    "data-name": "Path 15690",
    d: "M2787.135,1897.24c.188,6.093.046,11.51.212,16.011l17.219-9.937.012-21.373C2795.8,1887,2787.03,1893.808,2787.135,1897.24Z",
    transform: "translate(1.367 2.461)",
    fill: "#7bbdfd",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15691",
    "data-name": "Path 15691",
    d: "M2787.667,1897.337c.092,3.162.1,6.078.1,8.9.015,2.273.015,4.435.072,6.413l16.414-9.467.011-20.412c-9.748,5.706-16.694,11.783-16.6,14.566Zm-.213,16.435a.527.527,0,0,1-.212-.049.473.473,0,0,1-.212-.351c-.071-2.174-.082-4.583-.092-7.133,0-2.812-.01-5.726-.106-8.877h0c-.116-3.73,8.773-10.562,17.643-15.674a.4.4,0,0,1,.412,0,.418.418,0,0,1,.208.361l-.011,21.373a.413.413,0,0,1-.2.362l-17.234,9.935a.378.378,0,0,1-.2.053Z",
    transform: "translate(1.261 2.353)",
    fill: "#2874e7",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15692",
    "data-name": "Path 15692",
    d: "M2783.527,1894.421c.085-.345.188-.736.318-1.155,1.63-3.4,9.277-9.076,17-13.458l2.956,1.7,2.041,1.174c-4.435,2.609-15.307,9.043-17.362,14.617l-4.95-2.857Z",
    transform: "translate(0.106 1.715)",
    fill: "#7bbdfd",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15693",
    "data-name": "Path 15693",
    d: "M2784.118,1894.349l4.269,2.464c2.394-5.374,12.258-11.372,16.728-14.014l-4.165-2.406c-8.366,4.773-15.19,10.169-16.623,13.159-.071.259-.152.531-.209.8Zm4.466,3.479a.391.391,0,0,1-.2-.055l-4.965-2.858a.421.421,0,0,1-.2-.382.271.271,0,0,1,.013-.1c.083-.354.184-.75.315-1.177,1.8-3.763,9.926-9.575,17.2-13.7a.417.417,0,0,1,.413,0l4.987,2.878a.418.418,0,0,1,.208.361.431.431,0,0,1-.2.356c-4.154,2.443-15.168,8.936-17.183,14.405a.412.412,0,0,1-.39.273Z",
    transform: "translate(0 1.608)",
    fill: "#2874e7",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15694",
    "data-name": "Path 15694",
    d: "M2783.527,1890.655l.4,20.748c.153,8.052,3.017,8.249,9.036,11.721-3.346-2.331-3.9-6.2-4.212-10.18l-.272-19.433Z",
    transform: "translate(0.106 5.507)",
    fill: "#c8e6fe",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15695",
    "data-name": "Path 15695",
    d: "M2784.068,1891.49l.375,20.017c.132,6.555,2.041,7.674,6.242,9.935-1.617-2.312-2-5.271-2.242-8.358l-.27-19.22Zm9,32.159a.4.4,0,0,1-.2-.057c-.881-.5-1.675-.934-2.416-1.332-4.458-2.409-6.7-3.616-6.837-10.739l-.389-20.752a.4.4,0,0,1,.2-.365.425.425,0,0,1,.426,0l4.95,2.857a.437.437,0,0,1,.212.358l.269,19.43c.3,3.91.845,7.622,4.034,9.847a.419.419,0,0,1-.243.757Z",
    transform: "translate(0 5.399)",
    fill: "#2874e7",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15696",
    "data-name": "Path 15696",
    d: "M2783.845,1907.426l4.763,2.785v-.007l-.013-.1a5.91,5.91,0,0,1,.1-1.132l-.223-15.461-4.95-2.857Z",
    transform: "translate(0.106 5.507)",
    fill: "#7bbdfd",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15697",
    "data-name": "Path 15697",
    d: "M2784.362,1907.292l3.953,2.312a5.911,5.911,0,0,1,.082-.6l-.224-15.144-4.1-2.374.294,15.8Zm4.339,3.437a.364.364,0,0,1-.2-.052l-4.763-2.787a.42.42,0,0,1-.2-.35l-.317-16.771a.4.4,0,0,1,.2-.365.424.424,0,0,1,.425,0l4.95,2.857a.437.437,0,0,1,.212.358l.208,15.458a6.239,6.239,0,0,0-.092,1.128v.111a.422.422,0,0,1-.212.365.432.432,0,0,1-.212.049Z",
    transform: "translate(0 5.399)",
    fill: "#2874e7",
    fillRule: "evenodd"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStaticMessage);
export default __webpack_public_path__ + "static/media/static-message.cae385acbf5ed77d3e5fd5fc204efe15.svg";
export { ForwardRef as ReactComponent };